/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Badge } from 'ui/atoms/Badge/Badge';

import styles from './CompanyRecordCard.module.scss';

import type { CompanyRecordCardProps } from './CompanyRecordCard.types';

const COLS: { label: string; value: string; green?: boolean }[][] = [
  [
    { label: 'Registered Address', value: '14 Harbour Wharf, London E14 9GE' },
    { label: 'Legal Form', value: 'Private Limited Company' },
  ],
  [
    { label: 'Incorporated', value: '12 Mar 2016' },
    { label: 'VAT', value: 'GB 553 2871 09 · ✓ Valid', green: true },
  ],
];

const STATS: { label: string; value: string }[] = [
  { label: 'Revenue', value: '£12.4M' },
  { label: 'Net Profit', value: '£1.8M' },
  { label: 'Employees', value: '47' },
];

export const CompanyRecordCard = ({ className }: CompanyRecordCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.head}>
      <span className={styles.avatar}>AT</span>
      <div>
        <div className={styles.name}>
          Acme Trading Ltd
          <Badge variant="emerald" size="sm">
            Active
          </Badge>
        </div>
        <div className={styles.reg}>Reg. 10254891 · Companies House (UK)</div>
      </div>
    </div>

    <div className={styles.body}>
      {COLS.map((col, i) => (
        <div key={i} className={styles.cols}>
          {col.map((item) => (
            <div key={item.label}>
              <div className={styles.k}>{item.label}</div>
              <div className={cn(styles.v, item.green && styles.vGreen)}>{item.value}</div>
            </div>
          ))}
        </div>
      ))}

      <div className={styles.stats}>
        {STATS.map((stat) => (
          <div key={stat.label} className={styles.stat}>
            <div className={styles.k}>{stat.label}</div>
            <div className={styles.statValue}>{stat.value}</div>
          </div>
        ))}
      </div>
    </div>

    <div className={styles.source}>source: government registry record · synced daily</div>
  </div>
);
